import {Stack, Typography} from '@mui/material';
import {GuideFilterEnum} from 'main/analytics/gaTagsEnum';
import {StyledGrid} from 'presentation/components';
import {FeaturesEnum, PlanTypeEnum, QueryParamsEnum} from 'presentation/constants';
import {useMediaQueries, useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';

import {ServiceCard} from './ServiceCard';
import {ServiceCardsSkeleton} from './ServiceCardsSkeleton';
import {ServiceCardsProps} from './types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {getServiceInfo} from '../../../utils/getServiceInfo';

const {serviceType: serviceTypeLabel} = translations['pt-br'].privateFlow.guideFlow;

export function ServiceCards({type, services, isLoading}: ServiceCardsProps) {
	const {isMobile} = useMediaQueries();
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {serviceType} = SEARCH_PARAMS;
	const {isEnabled: isSemanticSearchEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SEMANTIC_SEARCH_MEDICAL_GUIDE,
	);

	const servicesFiltered = services?.filter(service => service?.nome);

	const handleSelectService = (serviceName: string) => {
		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SPECIALTY_CODE);
				prev.delete(QueryParamsEnum.SPECIALTY_NAME);
				prev.delete(QueryParamsEnum.NETWORK_CODE);
				prev.delete(QueryParamsEnum.NETWORK_TYPE);
				prev.delete(QueryParamsEnum.PROCEDURE);
				prev.set(QueryParamsEnum.SERVICE_TYPE, serviceName || '');
				return prev;
			},
			{replace: true},
		);
	};

	const servicesGuideTagging =
		type === PlanTypeEnum.HEALTH
			? GuideFilterEnum.APLICOU_FILTRO_SERVICO_SAUDE
			: GuideFilterEnum.APLICOU_FILTRO_SERVICO_ODONTO;

	if (isLoading) {
		return <ServiceCardsSkeleton />;
	}

	return (
		<Stack gap={1}>
			<Typography variant="body2" fontWeight={600} color="text.secondary">
				{serviceTypeLabel}
			</Typography>
			<StyledGrid.Root spacing={1}>
				{servicesFiltered?.map(service => {
					const {icon, label} = getServiceInfo(service.nome, isSemanticSearchEnabled);

					return (
						<StyledGrid.Item
							key={service.nome}
							xs={isMobile ? 12 : 6}
							sm={4}
							md={6}
							lg={4}
							xl={3}>
							<ServiceCard
								icon={icon}
								title={label}
								handleClick={() => handleSelectService(service?.nome || '')}
								hasEmphasis={serviceType === service?.nome}
								dataTagId={servicesGuideTagging}
							/>
						</StyledGrid.Item>
					);
				})}
			</StyledGrid.Root>
		</Stack>
	);
}
